import Vue from 'vue'
import { uniqid, clone, sample, samples, shuffle, sample_by_probability } from '@/js/utils'
import { generate_level, generate_hero, generate_card, get_card_value, generate_talisman } from '@/js/board'
import { fire_trigger } from '@/js/triggers'
import { fire_scroll } from '@/js/scrolls'
import { generate_status, trigger_status } from '@/js/status'
import data_cards from '@/data/data_cards'
import data_talismans from '@/data/cards/data_talismans'
import Sounds from '@/js/sounds'
import Musics from '@/js/musics'

// const biomes = [ { slug: 'temple-day' }, { slug: 'autumn-day' }, { slug: 'autumn-night' }, { slug: 'winter-day' }, { slug: 'winter-night' }, { slug: 'dolmen-day' }, { slug: 'dolmen-night' } ]


// === STATE =====================================================================================
const default_state = {
	status: 'loading',
	hero: null,
	board: [],
	hand: [],
	levels: [],
	fight: null,
	current_turn: 0,
	current_level: -1,
	dragging: null,
	shop: null,
	stats: [],
	final_score: 0
}
const state = clone(default_state)






// === GETTERS =====================================================================================
const getters = {
	game(state) { return state },
	hero(state) { return state.hero },
	room(state) { return Math.floor(state.hero.position / 7) },
	level(state) { return state.levels[state.current_level] },
	card_modifiers(state) {
		let modifiers = { life: 0, gold: 0, poison: 0, weakness: 0, strength: 0, enemy_attack: 0, enemy_armor: 0, enemy_life: 0, weapon_attack: 0, weapon_durability: 0, shield_armor: 0, shield_durability: 0, price: 0 }

		const config = [
			{  },
			{ enemy_attack: 1 },
			{ enemy_attack: 1, enemy_life: 1, weapon_attack: 1, shield_armor: 1 },
			{ enemy_attack: 2, enemy_life: 1, weapon_attack: 1, shield_armor: 1 },
			{ enemy_attack: 2, enemy_life: 2, weapon_attack: 2, shield_armor: 2 },
			{ enemy_attack: 3, enemy_life: 2, weapon_attack: 2, shield_armor: 2 },
			{ enemy_attack: 3, enemy_life: 3, weapon_attack: 2, shield_armor: 2 },
		]
		modifiers = { ...modifiers, ...config[state.current_level] }

		state.hero.talismans.forEach((talisman) => {
			if (talisman.slug === 'goldsun-brooch') modifiers.gold += 1
			else if (talisman.slug === 'zombie-hand') { modifiers.life += 1; modifiers.poison += 1 }
			else if (talisman.slug === 'ring') modifiers.price -= 3
			else if (talisman.slug === 'wounded-heart') modifiers.weapon_attack += 1
			else if (talisman.slug === 'keeps') modifiers.weapon_durability += 1
			else if (talisman.slug === 'amphora') modifiers.shield_durability += 1
			else if (talisman.slug === 'baby-bird' && !state.hero.equipments.length) { modifiers.enemy_attack -= 1 }
		})

		return modifiers
	},
	hero_modifiers(state, getters) {
		const modifiers = { life: 0, attack: 0, armor: 0, nb_cards: 0, shop_reroll_price: 0, hand_reroll_price: 0 }

		if (state.hero.equipments.filter(e => e && e.slug === 'dagger').length >= 2) modifiers.attack += 4

		state.hero.equipments.forEach((equipment) => {
			if (equipment) {
				if (equipment.type === 'weapon') modifiers.attack += get_card_value(equipment, 'attack')
				else if (equipment.type === 'shield') modifiers.armor += get_card_value(equipment, 'armor')
				else if (equipment.slug === 'lance') modifiers.attack += state.board.filter(c => c.type === 'enemy' && c.room === getters.room).length
			}
		})

		state.hero.talismans.forEach((talisman) => {
			if (talisman.slug === 'fork') modifiers.attack += 1
			else if (talisman.slug === 'flower') modifiers.life += 1
			else if (talisman.slug === 'gnome') modifiers.nb_cards += 1
			else if (talisman.slug === 'shop-dice') modifiers.shop_reroll_price -= 2
			else if (talisman.slug === 'hand-dice') modifiers.hand_reroll_price -= 1
		})

		return modifiers
	},
	nb_cards(state, getters) {
		if (state.hero) return state.hero.nb_cards + getters.hero_modifiers.nb_cards
		return 0
	},
	shop_reroll_price(state, getters) {
		let value = null
		if (state.hero) {
			value = state.hero.shop_reroll_price + getters.hero_modifiers.shop_reroll_price
			if (value < 1) value = 1
			return value
		}
		return null
	},
	hand_reroll_price(state, getters) {
		let value = null
		if (state.hero) {
			value = state.hero.hand_reroll_price + getters.hero_modifiers.hand_reroll_price
			if (value < 1) value = 1
			return value
		}
		return null
	}
}







// === ACTIONS =====================================================================================
const actions = {

	init_game({ commit, dispatch }, data) {
		const hero = generate_hero({ slug: data.hero })
		let levels = []
		shuffle([ 'dolmen', 'autumn', 'winter' ]).forEach((slug) => {
			levels.push({ id: uniqid(), biome: { slug: slug + '-day' } })
			levels.push({ id: uniqid(), biome: { slug: slug + '-night' } })
		})
		levels.push({ id: uniqid(), biome: { slug: 'temple-day' } })
		commit('EDIT_GAME_STATE', { ...default_state, levels, hero })

		dispatch('init_next_level')

		Musics.play(levels[0].biome.slug)
	},

	restart_game({ state, dispatch }, data) {
		dispatch('init_game', { hero: state.hero.slug })
	},


	init_next_level({ state, commit, dispatch, rootGetters }) {
		const board = generate_level({ tuto: rootGetters.user.viewed_tutos.length === 0 })
		const hero = { ...state.hero, position: 0 }
		commit('EDIT_GAME_STATE', { board, hero, current_level: state.current_level + 1 })

		dispatch('draw')
		setTimeout(() => {
			commit('EDIT_GAME_STATE', {  status: 'ready' })

			dispatch('trigger_tuto', { trigger: 'on-start-game' })
			// dispatch('end_game')
			// dispatch('open_shop')
		}, 500)

		// dispatch('add_card_status', { card: state.hero, status: 'strength', value: 4, turn: -1 })
		// dispatch('add_card_status', { card: state.hero, status: 'poison', value: 3, turn: -1 })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'cursed-shield', level: 2 }) })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'cursed-shield', level: 2 }) })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'mace', level: 0 }) })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'mace', level: 0 }) })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'dagger', level: 0 }) })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'dagger', level: 0 }) })
		// dispatch('add_equipment', { character: state.hero, equipment: generate_card({ slug: 'sword', level: 2 }) })
		// dispatch('add_talisman', { talisman: generate_talisman({ slug: 'dragonfly-flask' }) })
		// dispatch('add_talisman', { talisman: generate_talisman({ slug: 'ear' }) })
	},


	play_card({ state, commit }, data = {}) {
		if (data.card && data.position !== undefined) {
			if (data.card.type === 'scroll') {
				fire_scroll(data.card, data.position)
			}
			else {
				const card = { ...data.card, position: data.position }
				const board = [ ...state.board, card ]
				commit('EDIT_GAME_STATE', { board })
			}
			fire_trigger('play-card-' + data.card.type, { from_character: state.hero, card: data.card })

			const hand = state.hand.filter(c => c.id !== data.card.id)
			commit('EDIT_GAME_STATE', { hand })
		}
	},


	reroll_hand({ commit, dispatch, getters }) {
		if (state.hero.gold >= getters.hand_reroll_price) {
			Sounds.play('reroll')
			commit('EDIT_GAME_STATE', { hand: [] })
			setTimeout(() => {
				dispatch('draw')
			}, 100)
			commit('EDIT_GAME_OBJ', { obj: state.hero, gold: state.hero.gold - getters.hand_reroll_price })
		}
	},
	

	discard_card({ state, commit }) {
		if (state.hand.length) {
			const card = sample(state.hand)
			if (card) commit('EDIT_GAME_STATE', { hand: state.hand.filter(c => c !== card) })
		}
	},
	

	draw({ state, commit, getters, rootGetters }) {
		let hand = [ ...state.hand ]

		if (rootGetters.user.viewed_tutos.length === 0) {
			hand = [
				generate_card({ slug: 'sword', level: 0 }),
				generate_card({ slug: 'emerald', level: 0 }),
				generate_card({ slug: 'wooden-shield', level: 0 }),
				generate_card({ slug: 'health-potion', level: 0 }),
				generate_card({ slug: 'hammer', level: 0 }),
			]
		}

		else {
			const cards = data_cards.filter(c => !state.hero.cards.excludes.includes(c.slug))
			for (var i = state.hand.length; i < getters.nb_cards; i++) {
				const type = sample_by_probability(state.hero.cards.types)
				const card = sample(cards.filter(c => c.type === type.type))
				hand.push(generate_card({ slug: card.slug }))
			}
		}
		commit('EDIT_GAME_STATE', { hand })
	},


	

	start_turn({ state, commit, dispatch }) {
		commit('EDIT_GAME_STATE', { status: 'playing' })

		const next_card = state.board.find((c) => c.position === state.hero.position + 1)
		if (next_card) {
			if (next_card.type === 'enemy') {
				dispatch('start_fight', { hero: state.hero, opponent: next_card })
			} else {

				if (next_card.type === 'weapon' || next_card.type === 'shield') {
					dispatch('add_equipment', { character: state.hero, equipment: next_card })
				}

				else if (next_card.type === 'gold') {
					commit('EDIT_GAME_OBJ', { obj: state.hero, gold: state.hero.gold + get_card_value(next_card, 'gold') })
				}

				else if (next_card.slug === 'health-potion') {
					commit('EDIT_GAME_OBJ', { obj: state.hero, life: state.hero.life + get_card_value(next_card, 'life') })
					Sounds.play('potion')
				}

				else if (next_card.slug === 'poison-potion') {
					dispatch('add_card_status', { card: state.hero, status: 'poison', value: get_card_value(next_card, 'poison'), turn: state.current_turn + 1 })
					Sounds.play('potion')
				}

				else if (next_card.slug === 'weakness-potion') {
					dispatch('add_card_status', { card: state.hero, status: 'weakness', value: get_card_value(next_card, 'weakness'), turn: state.current_turn + 1 })
					Sounds.play('potion')
				}

				else if (next_card.slug === 'strength-potion') {
					dispatch('add_card_status', { card: state.hero, status: 'strength', value: get_card_value(next_card, 'strength'), turn: state.current_turn + 1 })
					Sounds.play('potion')
				}

				else if (next_card.slug === 'feather') {
					const enemy = state.board.find((c) => c.type === 'enemy' && c.position === next_card.position + 1)
					if (enemy) {
						dispatch('push_card', { card: enemy })
					}
				}

				else if (next_card.slug === 'pikes-trap') {
					dispatch('deal_damage', { victim: state.hero, damage: 1 })
					Sounds.play('pikes-trap')
				}

				else if (next_card.slug === 'wolf-trap') {
					dispatch('use_equipments', { character: state.hero })
					Sounds.play('wolf-trap')
				}

				else if (next_card.slug === 'puddle') {
					dispatch('draw_card', { card: generate_card({ slug: 'poison-potion' }) })
					Sounds.play('puddle')
				}

				else if (next_card.type === 'talisman') {
					dispatch('add_talisman', { talisman: next_card })
				}

				fire_trigger('get-card-' + next_card.slug, { from_character: state.hero })

				dispatch('move')
			}
		} else
			dispatch('move')
	},


	draw_card({ state, commit, getters }, data) {
		const hand = [ ...state.hand ]
		if (hand.length < getters.nb_cards) {
			hand.push(data.card)
			commit('EDIT_GAME_STATE', { hand })
		}
	},


	move({ state, commit, dispatch }) {
		const next_card = state.board.find((c) => c.position === state.hero.position + 1)
		const hero = { ...state.hero, position: state.hero.position + 1, animation: 'move' }
		const board = next_card ? state.board.filter(c => next_card.id !== c.id) : state.board
		commit('EDIT_GAME_STATE', { hero, board, current_turn: state.current_turn + 1 })
		setTimeout(() => {
			dispatch('end_turn')
		}, 600)
	},


	add_equipment({ state, commit }, data) {
		if (data.equipment) {
			let equipments = [ ...data.character.equipments ]
			if (equipments.length >= 2) {
				let oldest = equipments.reduce((acc, equipment) => {
					return equipment.turn < acc.turn ? equipment : acc
				})
				const index = oldest ? equipments.findIndex(e => e.id === oldest.id) : 0
				equipments[index] = { ...data.equipment, turn: state.current_turn, slot: oldest.slot }
			} else {
				const slot = equipments.find(e => e.slot === 0) ? 1 : 0
				equipments.push({ ...data.equipment, turn: state.current_turn, slot })
			}
			
			commit('EDIT_GAME_OBJ', { obj: data.character, equipments })
			Sounds.play('equipment')
		}
	},

	use_equipments({ commit }, data) {
		let removes = []
		data.character.equipments.forEach((equipment) => {
			if (equipment && (!data.type || equipment.type === data.type)) {
				const durability = equipment.durability - 1
				commit('EDIT_GAME_OBJ', { obj: equipment, durability })
				if (get_card_value(equipment, 'durability') <= 0) {
					removes.push(equipment.id)
				}
			}
		})
		if (removes.length) commit('EDIT_GAME_OBJ', { obj: data.character, equipments: data.character.equipments.filter(equipment => equipment && !removes.includes(equipment.id)) })
	},



	start_fight({ commit, dispatch }, data) {
		fire_trigger('before-fight', { from_character: state.hero })

		let fight = {}
		if (data.opponent.passives.includes('attack-first') && !data.hero.passives.includes('attack-first')) {
			fight = { attacker: data.opponent, victim: data.hero, turns: [] }
		} else {
			fight = { attacker: data.hero, victim: data.opponent, turns: [] }
		}
		commit('EDIT_GAME_STATE', { fight })
		// fire_trigger('start-fight', { from_character: data.hero, opponent: data.opponent })
		// fire_trigger('start-fight', { from_character: data.opponent, opponent: data.hero })
		dispatch('next_fight_turn')
	},

	next_fight_turn({ state, commit, dispatch }) {
		const attacker = state.fight.turns.length ? state.fight.turns[state.fight.turns.length - 1].victim : state.fight.attacker
		const victim = state.fight.turns.length ? state.fight.turns[state.fight.turns.length - 1].attacker : state.fight.victim

		if (attacker.position === victim.position - 1 || attacker.position === victim.position + 1) {
			const turn = { victim, attacker }
			
			// const values = get_attack_damage({ attacker, victim })
			const damage = get_card_value(attacker, 'attack')
			const full_block = get_card_value(victim, 'armor') >= damage
			dispatch('deal_damage', { victim, damage })
			
			commit('EDIT_GAME_OBJ', { obj: attacker, animation: attacker.type === 'hero' ? 'attack-right' : 'attack-left' })
			if (attacker.type === 'hero') Sounds.play('attack')
			// Sounds.play(victim.slug)
			// commit('EDIT_GAME_OBJ', { obj: victim, animation: attacker.type === 'hero' ? 'hit-right' : 'hit-left' })

			const fight = { ...state.fight, turns: [ ...state.fight.turns, turn ] }
			commit('EDIT_GAME_STATE', { fight })

			fire_trigger('after-attack', { from_character: attacker, opponent: victim })
			if (full_block) {
				fire_trigger('after-full-block', { from_character: victim, opponent: attacker })
			} else {
				fire_trigger('after-not-full-block', { from_character: victim, opponent: attacker })
				fire_trigger('after-deal-damage', { from_character: attacker, opponent: victim })
			}

			dispatch('use_equipments', { type: 'shield', character: victim })
			dispatch('use_equipments', { type: 'weapon', character: attacker })

			const loser = get_card_value(victim, 'life') <= 0 ? victim : get_card_value(attacker, 'life') <= 0 ? attacker : null
			// if (loser) Sounds.play(victim.slug)
			setTimeout(() => {
				if (loser) {
					const winner = get_card_value(victim, 'life') > 0 ? victim : attacker
					commit('EDIT_GAME_OBJ', { obj: winner, animation: 'idle' })
					if (loser.type !== 'hero') {
						setTimeout(() => {
							dispatch('start_turn')
						}, 750)
					}
				}
				else {
					dispatch('next_fight_turn')
				}
			}, 1000)
		} else
			dispatch('move')

	},

	deal_damage({ state, commit, dispatch }, data) {
		if (data.victim && data.damage && data.victim.life !== undefined) {
			
			let values = {}
			const damage = data.damage - get_card_value(data.victim, 'armor')
			if (damage > 0) {
				values.life = data.victim.life - damage
			}

			if (values) {
				commit('EDIT_GAME_OBJ', { obj: data.victim, ...values })
				commit('EDIT_APP_STATE', { shaking: Date.now() })

				if (!data.no_animation) {
					const animation_duration = data.animation_duration ? data.animation_duration : 1000
					commit('EDIT_GAME_OBJ', { obj: data.victim, animation: data.victim.type === 'hero' ? 'hit-left' : 'hit-right' })
					setTimeout(() => {
						commit('EDIT_GAME_OBJ', { obj: data.victim, animation: 'idle' })
					}, animation_duration)
				}

				if (data.victim.type !== 'hero') {
					setTimeout(() => {
						if (get_card_value(data.victim, 'life') <= 0) {
							fire_trigger('death', { from_character: data.victim })
							dispatch('loot', { card: data.victim })
							dispatch('add_game_stat', { killed_enemies: 1 })
						} 
					}, 500)
				}
			}

		}
	},

	push_card({ state, commit, dispatch }, data) {
		if (data.card.position < 20) {
			const next_card = state.board.find(c => c.position === data.card.position + 1)

			let allow = !next_card ? true : false

			if (next_card) {
				if (next_card.type === 'item' || next_card.type === 'trap') {
					if (next_card.slug === 'weakness-potion') {
						dispatch('add_card_status', { card: data.card, status: 'weakness', value: next_card.weakness })
					}
					else if (next_card.slug === 'poison-potion') {
						dispatch('add_card_status', { card: data.card, status: 'poison', value: next_card.poison })
					}
					else if (next_card.slug === 'strength-potion') {
						dispatch('add_card_status', { card: data.card, status: 'strength', value: next_card.strength })
					}
					else if (next_card.slug === 'health-potion') {
						commit('EDIT_GAME_OBJ', { obj: data.card, life: data.card.life + next_card.life })
					}
					else if (next_card.slug === 'wolf-trap') {
						dispatch('deal_damage', { victim: data.card, damage: 1 })
					}
					else if (next_card.slug === 'pikes-trap') {
						dispatch('deal_damage', { victim: data.card, damage: 1 })
					}
					else if (next_card.slug === 'puddle') {
						dispatch('add_card_status', { card: data.card, status: 'poison', value: 1 })
					}
					allow = true
				}
			}

			if (allow) {
				commit('EDIT_GAME_OBJ', { obj: data.card, position: data.card.position + 1, animation: 'pushing' })
				if (next_card) commit('EDIT_GAME_STATE', { board: state.board.filter(c => c.id !== next_card.id) })
				setTimeout(() => {
					commit('EDIT_GAME_OBJ', { obj: data.card, animation: 'idle' })
				}, 500)
			}
		}
	},

	loot({ state, commit }, data) {
		if (data.card && get_card_value(data.card, 'life') <= 0) {
			commit('EDIT_GAME_STATE', { board: state.board.filter(c => c.id !== data.card.id) })
			setTimeout(() => {
				let loot = data.card.boss ? generate_talisman({ slug: 'flower' }) : generate_card({ slug: 'emerald', level: data.card.level })
				loot.position = data.card.position
				commit('EDIT_GAME_STATE', { board: [ ...state.board, loot ] })
			}, 150)
		}
	},

	end_turn({ state, commit, dispatch }) {

		const hero_status = [ ...state.hero.status ]
		hero_status.forEach((copy) => {
			const status = state.hero.status.find(s => s.slug === copy.slug)
			trigger_status({ card: state.hero, status })
		})

		state.board.filter(c => c.status).forEach((card) => {
			const card_status = [ ...card.status ]
			card_status.forEach((copy) => {
				const status = card.status.find(s => s.slug === copy.slug)
				trigger_status({ card, status })
			})
		})

		commit('EDIT_GAME_STATE', { hero: { ...state.hero, animation: 'idle' } })

		if (state.hero.position >= 20) {
			if (state.current_level === state.levels.length - 1) {
				dispatch('end_game', { status: 'victory' })
			} else {
				dispatch('open_shop')
				dispatch('add_game_stat', { completed_levels: 1 })
				setTimeout(() => {
					dispatch('init_next_level')
				}, 1000)
			}
		} else {
			if (state.hero.position % 7 > 0) {
				setTimeout(() => {
					dispatch('start_turn')
				}, 300)
			} else {
				dispatch('draw')
				setTimeout(() => {
					commit('EDIT_GAME_STATE', { status: 'ready' })
				}, 500)
			}
		}
	},



	add_talisman({ state, commit }, data) {
		const talismans = [ ...state.hero.talismans, data.talisman ]
		commit('EDIT_GAME_OBJ', { obj: state.hero, talismans })
	},

	remove_talisman({ state, commit }, data) {
		commit('EDIT_GAME_OBJ', { obj: state.hero, talismans: state.hero.talismans.filter(t => t.id !== data.talisman.id) })
	},




	reroll_shop({ state, commit, dispatch, getters }) {
		if (state.hero.gold >= getters.shop_reroll_price) {
			Sounds.play('reroll')
			const actuals = state.shop.slots.map(t => (t.talisman) ? t.talisman.slug : '')
			const slugs = samples(data_talismans.filter(t => t.price && !actuals.includes(t.slug)).map(t => t.slug), 3)
			const slots = [
				{ id: uniqid(), talisman: generate_talisman({ slug: slugs[0] }) },
				{ id: uniqid(), talisman: generate_talisman({ slug: slugs[1] }) },
				{ id: uniqid(), talisman: generate_talisman({ slug: slugs[2] }) }
			]
			commit('EDIT_GAME_OBJ', { obj: state.shop, slots })
			commit('EDIT_GAME_OBJ', { obj: state.hero, gold: state.hero.gold - getters.shop_reroll_price })
		}
	},


	open_shop({ commit }) {
		const slugs = samples(data_talismans.filter(t => t.price).map(t => t.slug), 3)
		const shop = {
			slots: [
				{ id: uniqid(), talisman: generate_talisman({ slug: slugs[0] }) },
				{ id: uniqid(), talisman: generate_talisman({ slug: slugs[1] }) },
				{ id: uniqid(), talisman: generate_talisman({ slug: slugs[2] }) }
			]
		}
		commit('EDIT_GAME_STATE', { shop })
		Musics.play('shop')
		setTimeout(() => {
			Sounds.play('merchant')
		}, 750)
	},


	buy_talisman({ state, commit, dispatch }, data) {
		if (data.slot && data.slot.talisman) {
			const price = get_card_value(data.slot.talisman, 'price')
			if (state.hero.gold >= price) {
				dispatch('add_talisman', { talisman: data.slot.talisman })
				commit('EDIT_GAME_OBJ', { obj: state.hero, gold: state.hero.gold - price })

				Sounds.play('merchant')
				
				const slots = clone(state.shop.slots)
				slots.find(s => s.id === data.slot.id).talisman = null
				commit('EDIT_GAME_OBJ', { obj: state.shop, slots })
			}
		}
	},


	close_shop({ state, commit, getters }) {
		commit('EDIT_GAME_STATE', { shop: null })
		Musics.play(getters.level.biome.slug)
	},




	end_game({ state, commit, dispatch, rootGetters }, data) {
		let final_score = 0
		state.stats.forEach((stat) => {
			if (stat.slug === 'collected_emeralds') final_score += stat.value
			else if (stat.slug === 'killed_enemies') final_score += stat.value * 2
			else if (stat.slug === 'completed_levels') final_score += stat.value * 3
		})
		const values = { ...data, final_score }
		commit('EDIT_GAME_STATE', { final_score })
		commit('EDIT_USER_STATE', { diamonds: rootGetters.user.diamonds + final_score })

		setTimeout(() => {
			dispatch('add_popup', { type: 'end-game', ...values })
			setTimeout(() => {
				dispatch('check_unlocks')
			}, 1500)
		}, 1000)
	},



	add_card_status({ commit, dispatch }, data) {
		if (data.status && data.card) {

			// On supprime tous les status si on reçoit immunité
			if (data.status === 'immunity') {
				clone(data.card.status).forEach((status) => {
					dispatch('remove_card_status', { card: data.card, status })
				})
			}
			
			if (data.status === 'poison' && data.card.passives.includes('poison-is-blindness')) {
				data.status = 'blindness'
			}
			if (!data.card.passives || !data.card.passives.includes(data.status + '-immune') && !data.card.status.find(s => s.slug === 'immunity')) {
				const all_status = clone(data.card.status)
				let status = all_status.find((s) => s.slug === data.status)
				if (status) {
					status.value += data.value
					commit('EDIT_GAME_OBJ', { obj: data.card, status: all_status })
				} else {
					if (data.card.status.length < 4) {
						const s = generate_status({ slug: data.status, value: data.value, turn: data.turn })
						commit('EDIT_GAME_OBJ', { obj: data.card, status: [ ...data.card.status, s ] })
						// fire_trigger('get-new-status', { status: s })
					} else
						console.log('ignore add status:', data.status)
				}
				if (data.card.life_max) fire_trigger('get-status-' + data.status, { from_character: data.card })
			}
		}
	},


	remove_card_status({ commit }, data) {
		if (data.status && data.card) {
			if ( ! (data.status.slug === 'immunity' && data.status.value === 'infinite')) {
				commit('REMOVE_STATUS_FROM_CARD', { card: data.card, status: data.status })
				// fire_trigger('lose-status-' + data.status.slug, { status: data.status })
			}
		}
	},


	add_game_stat({ commit }, data) {
		if (data) {
			const stats = clone(state.stats)
			Object.keys(data).forEach((slug) => {
				const stat = stats.find(s => s.slug === slug)
				if (stat) {
					stat.value += data[slug]
				} else {
					stats.push({ slug, value: data[slug] })
				}
			})
			commit('EDIT_GAME_STATE', { stats })
		}
	},


}



// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_GAME_STATE(state, data) {
		for (var i in data) {
			Vue.set(state, i, data[i])
		}
	},

	EDIT_GAME_OBJ(state, data) {
		if (data.obj) {
			if (data.life !== undefined && data.obj.life_max && data.life > data.obj.life_max) data.life = data.obj.life_max
			for (var i in data) {
				if (i !== 'obj') Vue.set(data.obj, i, data[i])
			}
		}
	},

	REMOVE_STATUS_FROM_CARD(state, data) {
		if (data.card && data.status) {
			let index = data.card.status.findIndex((s) => s.id === data.status.id)
			if (index > -1) data.card.status.splice(index, 1)
		}
	}

}

export default { state, getters, actions, mutations }
